export const SCAN_START = 'SCAN_START';
export const SCAN_SUCCESS = 'SCAN_SUCCESS';
export const SCAN_FAILURE = 'SCAN_FAILURE';
export const SCAN_RESET = 'SCAN_RESET';

export const startScan = (steamId, locale) => ({
  type: SCAN_START,
  payload: { steamId, locale },
});

// errorCode : 'steam_auth' | 'scan_failed'
export const scanError = (errorCode) => ({ type: SCAN_FAILURE, payload: errorCode });
export const scanReset = () => ({ type: SCAN_RESET });
